import script from "./whDOnceImg1_t3A.vue?vue&type=script&setup=true&lang=js"
export * from "./whDOnceImg1_t3A.vue?vue&type=script&setup=true&lang=js"

import "./whDOnceImg1_t3A.vue?vue&type=style&index=0&id=4ff636b8&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ff636b8"]])

export default __exports__